// Shared option/format helpers for the accounting-calendar custom-tag dialogs (month & year
// dropdowns, excluded-month display). Extracted here so CustomTagForm and DeleteTagDialog share
// a single definition instead of duplicating them inline.

const MONTH_NAMES = [
    'January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December',
];

// { label: "January", value: "01" } … values are zero-padded to match the API's YYYY-MM month.
export const MONTH_OPTIONS: { label: string; value: string }[] = MONTH_NAMES.map(
    (name, i) => ({ label: name, value: String(i + 1).padStart(2, '0') }),
);

// Year dropdown options: current year through current year + 10. Computed per call so the window
// tracks the current date rather than being frozen at module load.
export const buildYearOptions = (): { label: string; value: string }[] => {
    const currentYear = new Date().getFullYear();
    return Array.from({ length: 11 }, (_, i) => String(currentYear + i)).map(y => ({ label: y, value: y }));
};

// "YYYY-MM" -> "Month YYYY" for display (e.g. "2026-03" -> "March 2026").
export const formatExcludedMonth = (ym: string): string => {
    const [y, m] = ym.split('-');
    const monthName = MONTH_OPTIONS[Number(m) - 1]?.label ?? m;
    return `${monthName} ${y}`;
};
